"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8094],{

/***/ 4472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KO": function() { return /* binding */ saveUserContact; },
/* harmony export */   "bO": function() { return /* binding */ saveUserDates; },
/* harmony export */   "ok": function() { return /* binding */ getUserContact; },
/* harmony export */   "pG": function() { return /* binding */ getUserDates; },
/* harmony export */   "yq": function() { return /* binding */ clearUserDates; }
/* harmony export */ });
/* unused harmony export clearUserContact */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26042);
/* provided dependency */ var process = __webpack_require__(83454);
/* eslint-disable no-undef */ 
var STORAGE_KEY = "sxmsir_user_contact";
var DATES_STORAGE_KEY = "sxmsir_user_dates";
var getUserContact = function() {
    if (false) {}
    try {
        var stored = sessionStorage.getItem(STORAGE_KEY);
        return stored ? JSON.parse(stored) : {};
    } catch (error) {
        // Only log in development
        if (typeof process !== "undefined" && "production" === "development") {}
        return {};
    }
};
/**
 * Sanitize string input to prevent XSS
 * Removes HTML tags, script content, and event handlers
 * Defense-in-depth: sessionStorage data is not rendered as HTML but sanitize to prevent any misuse
 */ var sanitizeString = function(value) {
    if (typeof value !== "string") return value;
    // Remove script tags and their content
    var sanitized = value.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, "");
    // Remove all HTML tags (including malformed ones)
    sanitized = sanitized.replace(/<[^>]*>/g, "");
    // Remove event handler attributes that might be in text (onerror=, onclick=, etc.)
    sanitized = sanitized.replace(/on\w+\s*=\s*["'][^"']*["']/gi, "");
    // Remove javascript: protocol handlers
    sanitized = sanitized.replace(/javascript:/gi, "");
    // Remove data: URIs that could contain scripts
    sanitized = sanitized.replace(/data:text\/html[^,]*,/gi, "");
    return sanitized.trim();
};
/**
 * Validate and sanitize contact data before storage
 * Only allows whitelisted keys with appropriate types and field-specific length limits
 */ var validateContactData = function(data) {
    var allowedKeys = [
        "name",
        "email",
        "phone",
        "message",
        "preferredContact"
    ];
    // Field-specific maximum lengths to prevent DOS and ensure data quality
    var maxLengths = {
        name: 100,
        email: 254,
        phone: 20,
        message: 500,
        preferredContact: 50 // Enum-like value
    };
    var validated = {};
    Object.keys(data).forEach(function(key) {
        // Only allow whitelisted keys
        if (!allowedKeys.includes(key)) return;
        var value = data[key];
        // Validate and sanitize based on type
        if (typeof value === "string") {
            var sanitized = sanitizeString(value);
            var maxLength = maxLengths[key] || 100;
            // Only store non-empty strings within length limit
            if (sanitized.length > 0 && sanitized.length <= maxLength) {
                validated[key] = sanitized;
            }
        }
    });
    return validated;
};
var saveUserContact = function(data) {
    if (false) {}
    try {
        var existing = getUserContact();
        var validatedData = validateContactData(data);
        var updated = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, existing, validatedData);
        // Only save non-empty values
        Object.keys(updated).forEach(function(key) {
            if (!updated[key]) delete updated[key];
        });
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
    } catch (error) {
        if (typeof process !== "undefined" && "production" === "development") {}
    }
};
var clearUserContact = function() {
    if (false) {}
    try {
        sessionStorage.removeItem(STORAGE_KEY);
    } catch (error) {
        if (typeof process !== "undefined" && "production" === "development") {}
    }
};
var getUserDates = function() {
    if (false) {}
    try {
        var stored = sessionStorage.getItem(DATES_STORAGE_KEY);
        return stored ? JSON.parse(stored) : null;
    } catch (error) {
        if (typeof process !== "undefined" && "production" === "development") {}
        return null;
    }
};
var saveUserDates = function(dates) {
    if (false) {}
    try {
        // Validate that dates are moment objects or have toISOString method before serializing
        var data = {
            startDate: dates.startDate && typeof dates.startDate.toISOString === "function" ? dates.startDate.toISOString() : null,
            endDate: dates.endDate && typeof dates.endDate.toISOString === "function" ? dates.endDate.toISOString() : null,
            offsetable: dates.offsetable !== undefined ? dates.offsetable : 0
        };
        sessionStorage.setItem(DATES_STORAGE_KEY, JSON.stringify(data));
    } catch (error) {
        if (typeof process !== "undefined" && "production" === "development") {}
    }
};
var clearUserDates = function() {
    if (false) {}
    try {
        sessionStorage.removeItem(DATES_STORAGE_KEY);
    } catch (error) {
        if (typeof process !== "undefined" && "production" === "development") {}
    }
};


/***/ }),

/***/ 65079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AB": function() { return /* binding */ useSearchContext; },
/* harmony export */   "Nd": function() { return /* binding */ SearchContextProvider; }
/* harmony export */ });
/* unused harmony export SearchContext */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(29815);
/* harmony import */ var _home_forge_sxmsir_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_forge_sxmsir_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_forge_sxmsir_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _components_configs_axios__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92375);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(79697);
/* harmony import */ var lodash_es_isEqual__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50576);
/* harmony import */ var lodash_es_without__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(9092);
/* harmony import */ var lodash_es_omit__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70135);
/* harmony import */ var _components_helpers_userContactStorage__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4472);















var SearchContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.createContext)("default");
var useSearchContext = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(SearchContext);
    if (context === undefined) {
        throw new Error("useSearchContext was used outside of its Provider");
    }
    return context;
};
function SearchContextProvider(param) {
    var children = param.children;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var initialValues = {
        startDate: null,
        endDate: null,
        bedrooms: null,
        bathrooms: null,
        priceStart: null,
        priceEnd: null,
        amenities: [],
        homeType: [],
        location: [],
        listing: "",
        sorting: "default"
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), listing = ref[0], setListing = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), reset = ref2[0], setReset = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), offsetable = ref3[0], setOffsetable = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), searchActive = ref4[0], setSearchActive = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), loaded = ref5[0], setLoaded = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(initialValues), search = ref6[0], setSearch = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), reserved = ref7[0], setReserved = ref7[1];
    // Initialize dates correctly for calendar page - start from current month, end 2 months ahead
    var initialStartDate = router.pathname === "/calendar" ? moment__WEBPACK_IMPORTED_MODULE_6___default()().utc().startOf("month") : moment__WEBPACK_IMPORTED_MODULE_6___default()().utc();
    var initialEndDate = router.pathname === "/calendar" ? moment__WEBPACK_IMPORTED_MODULE_6___default()().utc().add(2, "months").endOf("month") : moment__WEBPACK_IMPORTED_MODULE_6___default()().utc();
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(initialStartDate), requestStartDate = ref8[0], setRequestStartDate = ref8[1];
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(initialEndDate), requestEndDate = ref9[0], setRequestEndDate = ref9[1];
    var ref10 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), error = ref10[0], setError = ref10[1];
    // Request tracking to prevent race conditions
    var ref11 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), requestId = ref11[0], setRequestId = ref11[1];
    var currentRequestIdRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(0);
    // AbortController Map for canceling in-flight requests
    // Maps request ID to AbortController for safer cleanup
    var abortControllersRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(new Map());
    // Track if initial load is complete
    var initialLoadComplete = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(false);
    // Track URL update source to prevent infinite loops
    var urlUpdateSource = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)("external");
    // Track last processed URL to prevent duplicate fetches
    var lastProcessedUrl = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    // Track if dates have been loaded from sessionStorage
    var datesLoadedFromStorage = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(false);
    // for single page
    var ref12 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), bedroomOptions = ref12[0], setBedroomOptions = ref12[1];
    var ref13 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), guests = ref13[0], setGuests = ref13[1];
    var isCalendarPage = router.asPath === "/calendar";
    var activeRoute = router.pathname === "/vacation-rentals" || router.pathname === "/real-estate/search" || router.pathname === "/calendar";
    var searchRoute = router.pathname === "/calendar" ? "calendar/search" : router.pathname === "/vacation-rentals" ? "listings/search" : "real-estate/search";
    var allPropertiesRoute = router.pathname === "/calendar" ? "calendar/blocked-dates" : router.pathname === "/vacation-rentals" ? "listings/index" : "real-estate/properties";
    // Helper function to parse and validate numeric URL parameters
    // Uses realistic property limits to prevent DOS attacks with oversized queries
    var parseNumericParam = function(value, defaultValue) {
        var min = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, max = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Number.MAX_SAFE_INTEGER;
        if (!value) return defaultValue;
        var parsed = Number(value);
        if (isNaN(parsed) || !isFinite(parsed)) return defaultValue;
        return Math.max(min, Math.min(max, parsed));
    };
    // Helper function to build URL params from search state
    var buildUrlParams = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        var searchState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        var stateToUse = searchState || search;
        var filtered = Object.keys(initialValues).filter(function(key) {
            return !(0,lodash_es_isEqual__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(stateToUse[key], initialValues[key]);
        }).reduce(function(obj, key) {
            obj[key] = stateToUse[key];
            return obj;
        }, {});
        if (filtered.startDate && moment__WEBPACK_IMPORTED_MODULE_6___default().isMoment(filtered.startDate)) {
            filtered.startDate = filtered.startDate.toISOString();
        }
        if (filtered.endDate && moment__WEBPACK_IMPORTED_MODULE_6___default().isMoment(filtered.endDate)) {
            filtered.endDate = filtered.endDate.toISOString();
        }
        return filtered;
    }, [
        search
    ]);
    // Helper function to update URL with shallow routing
    var updateUrl = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(params) {
        var filteredQuery = (0,lodash_es_omit__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(router.query, Object.keys(initialValues));
        var newQuery = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, filteredQuery, params);
        // Mark this as an internal URL update to prevent infinite loops
        urlUpdateSource.current = "internal";
        router.push({
            pathname: router.pathname,
            query: newQuery
        }, undefined, {
            shallow: true
        });
    }, [
        router
    ]);
    // Fetch all properties (no filters applied)
    var fetchAllProperties = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_home_forge_sxmsir_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(reqId) {
            var controller, cardFields, params, res, ref, ref1, errorMessage;
            return _home_forge_sxmsir_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        // Cancel any previous in-flight requests and clear map in one pass
                        abortControllersRef.current.forEach(function(controller) {
                            return controller.abort();
                        });
                        abortControllersRef.current.clear();
                        controller = new AbortController();
                        abortControllersRef.current.set(reqId, controller);
                        setLoading(true);
                        setError(null);
                        cardFields = [
                            "id",
                            "resource_id",
                            "nickname",
                            "city",
                            "propertyType",
                            "accommodates",
                            "bedrooms",
                            "bathrooms",
                            "picture",
                            "cloudflare_gallery",
                            "gallery",
                            "propertyTitle",
                            "is_exclusive",
                            "startingAt",
                            "min_price",
                            "total",
                            "welcome_description",
                            "propertyDescription",
                            "promotional",
                            "card_label",
                            "address"
                        ];
                        params = {
                            lang: router.locale,
                            startDate: isCalendarPage && requestStartDate && moment__WEBPACK_IMPORTED_MODULE_6___default().isMoment(requestStartDate) ? requestStartDate.format("YYYY-MM-DD") : moment__WEBPACK_IMPORTED_MODULE_6___default()().utc().format("YYYY-MM-DD"),
                            endDate: isCalendarPage && requestEndDate && moment__WEBPACK_IMPORTED_MODULE_6___default().isMoment(requestEndDate) ? requestEndDate.format("YYYY-MM-DD") : moment__WEBPACK_IMPORTED_MODULE_6___default()().utc().add(2, "years").format("YYYY-MM-DD"),
                            fields: router.pathname === "/vacation-rentals" ? cardFields : undefined
                        };
                        if (router.pathname === "/calendar") {
                            delete params.lang;
                        }
                        _ctx.prev = 9;
                        _ctx.next = 12;
                        return _components_configs_axios__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get(allPropertiesRoute, {
                            params: params,
                            signal: controller.signal
                        });
                    case 12:
                        res = _ctx.sent;
                        // Only update if this is still the current request
                        if (reqId === currentRequestIdRef.current) {
                            if ((0,lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(res.data)) {
                                setListing(res.data);
                            } else {
                                setListing(res.data[router.locale]);
                            }
                            setLoading(false);
                            setError(null);
                            // Clean up this request's controller
                            abortControllersRef.current.delete(reqId);
                        }
                        _ctx.next = 22;
                        break;
                    case 16:
                        _ctx.prev = 16;
                        _ctx.t0 = _ctx["catch"](9);
                        if (!axios__WEBPACK_IMPORTED_MODULE_4___default().isCancel(_ctx.t0)) {
                            _ctx.next = 21;
                            break;
                        }
                        abortControllersRef.current.delete(reqId);
                        return _ctx.abrupt("return");
                    case 21:
                        if (reqId === currentRequestIdRef.current) {
                            ;
                            console.error("Fetch all properties error:", _ctx.t0);
                            errorMessage = (_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref = _ctx.t0.response) === null || ref === void 0 ? void 0 : ref.status) === 404 ? "No properties found" : (_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref1 = _ctx.t0.response) === null || ref1 === void 0 ? void 0 : ref1.status) >= 500 ? "Server error. Please try again later" : "Unable to load properties. Please check your connection";
                            setListing([]);
                            setLoading(false);
                            setError(errorMessage);
                            abortControllersRef.current.delete(reqId);
                        }
                    case 22:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    9,
                    16
                ]
            ]);
        }));
        return function(reqId) {
            return _ref.apply(this, arguments);
        };
    }(), [
        router.locale,
        router.pathname,
        isCalendarPage,
        requestStartDate,
        requestEndDate,
        allPropertiesRoute
    ]);
    // Search properties with filters
    var searchProperties = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_home_forge_sxmsir_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(reqId, searchState) {
            var ref, ref1, controller, submittedStart, submittedEnd, submittedHomeType, params, res, ref2, ref3, errorMessage;
            return _home_forge_sxmsir_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        // Cancel any previous in-flight requests and clear map in one pass
                        abortControllersRef.current.forEach(function(controller) {
                            return controller.abort();
                        });
                        abortControllersRef.current.clear();
                        controller = new AbortController();
                        abortControllersRef.current.set(reqId, controller);
                        submittedStart = searchState.startDate && searchState.startDate.clone();
                        submittedEnd = submittedStart && searchState.endDate && searchState.endDate.clone();
                        submittedHomeType = (0,lodash_es_without__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(searchState === null || searchState === void 0 ? void 0 : searchState.homeType, "exclusive");
                        setLoading(true);
                        setError(null);
                        params = {
                            lang: router.locale,
                            listing: searchState.listing || "",
                            sorting: searchState.sorting || "default",
                            bedrooms: searchState.bedrooms,
                            bathrooms: searchState.bathrooms,
                            priceStart: searchState.priceStart,
                            priceEnd: searchState.priceEnd,
                            amenities: searchState.amenities || [],
                            location: searchState.location || [],
                            homeType: submittedHomeType,
                            exclusive: (searchState === null || searchState === void 0 ? void 0 : searchState.homeType.includes("exclusive")) ? true : null,
                            startDate: isCalendarPage && (requestStartDate === null || requestStartDate === void 0 ? void 0 : requestStartDate._d) ? requestStartDate : submittedStart ? (ref = submittedStart === null || submittedStart === void 0 ? void 0 : submittedStart.subtract(offsetable, "days")) === null || ref === void 0 ? void 0 : ref.format("YYYY-MM-DD") : null,
                            endDate: isCalendarPage && (requestEndDate === null || requestEndDate === void 0 ? void 0 : requestEndDate._d) ? requestEndDate : submittedEnd ? (ref1 = submittedEnd === null || submittedEnd === void 0 ? void 0 : submittedEnd.add(offsetable, "days")) === null || ref1 === void 0 ? void 0 : ref1.format("YYYY-MM-DD") : null,
                            // Only request fields needed for listing cards to reduce response size
                            fields: [
                                "id",
                                "resource_id",
                                "nickname",
                                "city",
                                "propertyType",
                                "accommodates",
                                "bedrooms",
                                "bathrooms",
                                "picture",
                                "cloudflare_gallery",
                                "gallery",
                                "propertyTitle",
                                "is_exclusive",
                                "startingAt",
                                "min_price",
                                "total",
                                "welcome_description",
                                "propertyDescription",
                                "promotional",
                                "card_label",
                                "address"
                            ]
                        };
                        _ctx.prev = 11;
                        _ctx.next = 14;
                        return _components_configs_axios__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get(searchRoute, {
                            params: params,
                            signal: controller.signal
                        });
                    case 14:
                        res = _ctx.sent;
                        // Only update if this is still the current request
                        if (reqId === currentRequestIdRef.current) {
                            if ((0,lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(res.data)) {
                                setListing(res.data);
                            } else {
                                setListing(res.data[router.locale]);
                            }
                            setLoading(false);
                            setError(null);
                            // Clean up this request's controller
                            abortControllersRef.current.delete(reqId);
                        }
                        _ctx.next = 24;
                        break;
                    case 18:
                        _ctx.prev = 18;
                        _ctx.t0 = _ctx["catch"](11);
                        if (!axios__WEBPACK_IMPORTED_MODULE_4___default().isCancel(_ctx.t0)) {
                            _ctx.next = 23;
                            break;
                        }
                        abortControllersRef.current.delete(reqId);
                        return _ctx.abrupt("return");
                    case 23:
                        if (reqId === currentRequestIdRef.current) {
                            ;
                            console.error("Search properties error:", _ctx.t0);
                            errorMessage = (_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref2 = _ctx.t0.response) === null || ref2 === void 0 ? void 0 : ref2.status) === 404 ? "No properties match your search" : (_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref3 = _ctx.t0.response) === null || ref3 === void 0 ? void 0 : ref3.status) >= 500 ? "Server error. Please try again later" : "Unable to search properties. Please check your connection";
                            setListing([]);
                            setLoading(false);
                            setError(errorMessage);
                            abortControllersRef.current.delete(reqId);
                        }
                    case 24:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    11,
                    18
                ]
            ]);
        }));
        return function(reqId, searchState) {
            return _ref.apply(this, arguments);
        };
    }(), [
        router.locale,
        isCalendarPage,
        requestStartDate,
        requestEndDate,
        offsetable,
        searchRoute
    ]);
    // Apply current filters - updates URL and fetches data
    // Accepts optional searchState to avoid React state timing issues
    var applyFilters = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        var searchState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        // Use provided state or fall back to current search state
        var stateToUse = searchState || search;
        // Increment request ID
        var newRequestId = requestId + 1;
        setRequestId(newRequestId);
        currentRequestIdRef.current = newRequestId;
        // Build and update URL params BEFORE fetching
        var params = buildUrlParams(stateToUse);
        updateUrl(params);
        // Fetch data with request tracking
        if ((0,lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(params)) {
            fetchAllProperties(newRequestId);
        } else {
            searchProperties(newRequestId, stateToUse);
        }
    }, [
        requestId,
        buildUrlParams,
        updateUrl,
        fetchAllProperties,
        searchProperties,
        search
    ]);
    // Reset all filters to initial values
    var resetFilters = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        // Increment request ID
        var newRequestId = requestId + 1;
        setRequestId(newRequestId);
        currentRequestIdRef.current = newRequestId;
        // Reset search state
        setSearch(initialValues);
        // Clear URL params
        updateUrl({});
        // Fetch all properties with no filters
        fetchAllProperties(newRequestId);
    }, [
        requestId,
        updateUrl,
        fetchAllProperties
    ]);
    // Enable the search on the search/real estate pages
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        !activeRoute && setSearchActive(false);
    }, [
        activeRoute
    ]);
    // Cleanup: cancel any in-flight requests when component unmounts
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        return function() {
            abortControllersRef.current.forEach(function(controller) {
                return controller.abort();
            });
            abortControllersRef.current.clear();
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        return setLoaded(true);
    }, []);
    // Load dates from sessionStorage on mount (client-side only)
    // This runs before navigation effects to ensure dates are available
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if ( false || datesLoadedFromStorage.current) return;
        var savedDates = (0,_components_helpers_userContactStorage__WEBPACK_IMPORTED_MODULE_7__/* .getUserDates */ .pG)();
        // Mark as loaded BEFORE updating state to prevent save effect from clearing
        datesLoadedFromStorage.current = true;
        if (savedDates && (savedDates.startDate || savedDates.endDate)) {
            var loadedDates = {
                startDate: savedDates.startDate ? moment__WEBPACK_IMPORTED_MODULE_6___default()(savedDates.startDate).utc() : null,
                endDate: savedDates.endDate ? moment__WEBPACK_IMPORTED_MODULE_6___default()(savedDates.endDate).utc() : null
            };
            setSearch(function(prevSearch) {
                return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, prevSearch, loadedDates);
            });
            // Also restore offsetable if it was saved
            if (savedDates.offsetable !== undefined) {
                setOffsetable(savedDates.offsetable);
            }
        }
    }, []);
    // Save dates and offsetable to sessionStorage when they change
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        // Only save after initial load
        if (!loaded) {
            return;
        }
        // Don't clear sessionStorage on initial mount - wait until dates have been loaded from storage
        // This prevents clearing dates that were just loaded from sessionStorage
        if (!datesLoadedFromStorage.current) {
            return;
        }
        // Don't clear during navigation - check if we're navigating to a page that should preserve dates
        // This prevents clearing dates when navigation effect hasn't finished loading them yet
        var isHomeOrVacationRentals = router.pathname === "/" || router.pathname === "/vacation-rentals";
        var isNavigatingToPreservePage = isHomeOrVacationRentals && !initialLoadComplete.current;
        // Clear sessionStorage if all dates are cleared and offsetable is 0
        // Only clear if this is an intentional clear (not during navigation or initial mount)
        if (!search.startDate && !search.endDate && offsetable === 0) {
            if (isNavigatingToPreservePage) {
                return;
            }
            (0,_components_helpers_userContactStorage__WEBPACK_IMPORTED_MODULE_7__/* .clearUserDates */ .yq)();
        } else {
            // Save dates immediately when they change (don't wait for datesLoadedFromStorage flag)
            // This ensures dates are persisted even if navigation happens quickly
            (0,_components_helpers_userContactStorage__WEBPACK_IMPORTED_MODULE_7__/* .saveUserDates */ .bO)({
                startDate: search.startDate,
                endDate: search.endDate,
                offsetable: offsetable
            });
        }
    }, [
        search.startDate,
        search.endDate,
        offsetable,
        loaded,
        router.pathname
    ]);
    // Single effect for navigation - handles initial load and browser back/forward
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!router.isReady || !activeRoute || !loaded) {
            return;
        }
        // Skip if this URL change was triggered internally by applyFilters
        if (urlUpdateSource.current === "internal") {
            urlUpdateSource.current = "external";
            return;
        }
        // Create unique key for current URL state to prevent duplicate processing
        // Include query string to properly detect changes in filters
        var currentUrlKey = "".concat(router.pathname, "|").concat(JSON.stringify(router.query), "|").concat(router.locale);
        // Skip if we've already processed this exact URL
        if (lastProcessedUrl.current === currentUrlKey) {
            return;
        }
        // Mark this URL as processed
        lastProcessedUrl.current = currentUrlKey;
        // Parse URL params and sync state
        if (!(0,lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(router.query)) {
            var _query = router.query, startDate = _query.startDate, endDate = _query.endDate, bedrooms = _query.bedrooms, bathrooms = _query.bathrooms, priceStart = _query.priceStart, priceEnd = _query.priceEnd, homeType = _query.homeType, location = _query.location, listing = _query.listing, amenities = _query.amenities, sorting = _query.sorting;
            // If dates are in URL, use them; otherwise preserve from sessionStorage or current state for home/vacation-rentals
            var isHomeOrVacationRentals = router.pathname === "/" || router.pathname === "/vacation-rentals";
            var preservedDates = {};
            if (isHomeOrVacationRentals && (!startDate || !endDate)) {
                // If dates not in URL, try to preserve from sessionStorage first, then current search state
                var savedDates = (0,_components_helpers_userContactStorage__WEBPACK_IMPORTED_MODULE_7__/* .getUserDates */ .pG)();
                if (savedDates && (savedDates.startDate || savedDates.endDate)) {
                    preservedDates = {
                        startDate: savedDates.startDate ? moment__WEBPACK_IMPORTED_MODULE_6___default()(savedDates.startDate).utc() : null,
                        endDate: savedDates.endDate ? moment__WEBPACK_IMPORTED_MODULE_6___default()(savedDates.endDate).utc() : null
                    };
                    // Also restore offsetable if it was saved
                    if (savedDates.offsetable !== undefined) {
                        setOffsetable(savedDates.offsetable);
                    }
                } else if (search.startDate || search.endDate) {
                    // Fall back to current search state if sessionStorage doesn't have dates
                    preservedDates = {
                        startDate: search.startDate,
                        endDate: search.endDate
                    };
                }
            }
            var parsedSearch = {
                location: typeof location === "string" ? [
                    location
                ] : !(0,lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(location) ? (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(location) : initialValues.location,
                amenities: typeof amenities === "string" ? [
                    amenities
                ] : !(0,lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(amenities) ? (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(amenities) : initialValues.amenities,
                homeType: typeof homeType === "string" ? [
                    homeType
                ] : !(0,lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(homeType) ? (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(homeType) : initialValues.homeType,
                priceStart: parseNumericParam(priceStart, initialValues.priceStart, 0, 5000000),
                priceEnd: parseNumericParam(priceEnd, initialValues.priceEnd, 0, 5000000),
                bedrooms: parseNumericParam(bedrooms, initialValues.bedrooms, 0, 20),
                bathrooms: parseNumericParam(bathrooms, initialValues.bathrooms, 0, 20),
                startDate: startDate ? moment__WEBPACK_IMPORTED_MODULE_6___default()(startDate).utc() : preservedDates.startDate !== undefined ? preservedDates.startDate : initialValues.startDate,
                endDate: endDate ? moment__WEBPACK_IMPORTED_MODULE_6___default()(endDate).utc() : preservedDates.endDate !== undefined ? preservedDates.endDate : initialValues.endDate,
                listing: listing ? listing : initialValues.listing,
                sorting: sorting ? sorting : initialValues.sorting
            };
            // Update state with parsed values
            setSearch(parsedSearch);
            // Fetch with parsed params
            var newRequestId = requestId + 1;
            setRequestId(newRequestId);
            currentRequestIdRef.current = newRequestId;
            searchProperties(newRequestId, parsedSearch);
        } else {
            // No URL params - preserve dates from sessionStorage or current search state for home/vacation-rentals pages
            // Only reset other filters, keep dates if they exist
            var isHomeOrVacationRentals1 = router.pathname === "/" || router.pathname === "/vacation-rentals";
            if (isHomeOrVacationRentals1) {
                // Check sessionStorage first, then fall back to current search state
                var savedDates1 = (0,_components_helpers_userContactStorage__WEBPACK_IMPORTED_MODULE_7__/* .getUserDates */ .pG)();
                var datesToPreserve = savedDates1 && (savedDates1.startDate || savedDates1.endDate) ? {
                    startDate: savedDates1.startDate ? moment__WEBPACK_IMPORTED_MODULE_6___default()(savedDates1.startDate).utc() : null,
                    endDate: savedDates1.endDate ? moment__WEBPACK_IMPORTED_MODULE_6___default()(savedDates1.endDate).utc() : null
                } : search.startDate || search.endDate ? {
                    startDate: search.startDate,
                    endDate: search.endDate
                } : {
                    startDate: null,
                    endDate: null
                };
                var preservedSearch = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, initialValues, datesToPreserve);
                setSearch(preservedSearch);
                // Also restore offsetable if it was saved
                if (savedDates1 && savedDates1.offsetable !== undefined) {
                    setOffsetable(savedDates1.offsetable);
                }
            } else {
                setSearch(initialValues);
            }
            var newRequestId1 = requestId + 1;
            setRequestId(newRequestId1);
            currentRequestIdRef.current = newRequestId1;
            fetchAllProperties(newRequestId1);
        }
        // Mark navigation as complete AFTER setting search state
        // This ensures save effect doesn't clear dates during navigation
        initialLoadComplete.current = true;
    // Note: requestId is intentionally excluded from dependencies as it's updated
    // inside this effect via currentRequestIdRef. Including it would cause infinite loops.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        router.pathname,
        router.query,
        router.isReady,
        loaded,
        activeRoute,
        router.locale,
        fetchAllProperties,
        searchProperties
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SearchContext.Provider, {
        value: {
            listing: listing,
            setListing: setListing,
            search: search,
            setSearch: setSearch,
            loading: loading,
            initialValues: initialValues,
            reset: reset,
            setReset: setReset,
            offsetable: offsetable,
            setOffsetable: setOffsetable,
            bedroomOptions: bedroomOptions,
            setBedroomOptions: setBedroomOptions,
            guests: guests,
            setGuests: setGuests,
            searchActive: searchActive,
            setSearchActive: setSearchActive,
            setReserved: setReserved,
            reserved: reserved,
            setRequestEndDate: setRequestEndDate,
            setRequestStartDate: setRequestStartDate,
            applyFilters: applyFilters,
            resetFilters: resetFilters,
            error: error
        },
        children: children
    });
}



/***/ }),

/***/ 4404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SF": function() { return /* binding */ CurrencyContextProvider; },
/* harmony export */   "VT": function() { return /* binding */ useCurrencyContext; }
/* harmony export */ });
/* unused harmony export CurrencyContext */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



var CurrencyContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)("default");
var useCurrencyContext = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(CurrencyContext);
    if (context === undefined) {
        throw new Error("useCurrencyContext was used outside of its Provider");
    }
    return context;
};
var CurrencyContextProvider = function(param) {
    var children = param.children;
    var defaultValue = "usd";
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(defaultValue), currency = ref[0], setCurrency = ref[1];
    var currencies = [
        {
            value: "usd",
            label: "$ USD",
            coin: "$"
        },
        {
            value: "eur",
            label: "€ EUR",
            coin: "€"
        }
    ];
    var selectedCurrency = currencies.find(function(item) {
        return item.value === currency;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CurrencyContext.Provider, {
        value: {
            currency: currency,
            setCurrency: setCurrency,
            currencies: currencies,
            defaultValue: defaultValue,
            selectedCurrency: selectedCurrency
        },
        children: children
    });
};



/***/ })

}]);